import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function SocialIconsRender({ node, isLiveMode }) {
  const content = node.content || {};
  
  const align = content.align || 'center';
  const size = content.size || '24px';
  const gap = content.gap || '16px';
  const colorMode = content.colorMode || 'brand'; // brand, custom
  const customColor = content.customColor || '#cbd5e1';

  // Simple Text-Logik um Auswahl darzustellen
  const networks = [
    { name: 'Facebook', show: content.showFacebook === 'true', symbol: 'f', brandColor: '#1877F2' },
    { name: 'Instagram', show: content.showInstagram === 'true', symbol: 'ig', brandColor: '#E4405F' },
    { name: 'LinkedIn', show: content.showLinkedIn === 'true', symbol: 'in', brandColor: '#0A66C2' },
    { name: 'X / Twitter', show: content.showX === 'true', symbol: '𝕏', brandColor: '#ffffff' },
    { name: 'YouTube', show: content.showYouTube === 'true', symbol: '▶', brandColor: '#FF0000' }
  ].filter(n => n.show);

  return (
    <div style={{
      display: 'flex',
      justifyContent: align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start',
      gap: gap,
      width: '100%',
      pointerEvents: !isLiveMode ? 'none' : 'auto'
    }}>
      {networks.map((net, idx) => (
        <a 
          key={idx} 
          href="#" 
          title={net.name}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: size,
            height: size,
            textDecoration: 'none',
            color: colorMode === 'brand' ? net.brandColor : customColor,
            fontSize: `calc(${size} * 0.6)`,
            fontWeight: 'bold',
            transition: 'opacity 0.2s',
            opacity: 0.85
          }}
          onMouseEnter={(e) => { e.currentTarget.style.opacity = '1'; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = '0.85'; }}
        >
          {net.symbol}
        </a>
      ))}
      {networks.length === 0 && (
        <span style={{ color: '#64748b', fontSize: '14px' }}>Keine Netzwerke ausgewählt</span>
      )}
    </div>
  );
}

registry.register('SocialIcons', {
  label: 'Social Media Icons',
  icon: '🔗', 
  category: 'basic', // oder advanced
  component: SocialIconsRender,
  
  defaultProps: {
    content: {
      showFacebook: 'true',
      showInstagram: 'true',
      showLinkedIn: 'true',
      showX: 'true',
      showYouTube: 'false',
      align: 'center',
      size: '32px',
      gap: '16px',
      colorMode: 'brand'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Sichtbarkeit der Netzwerke',
          fields: [
            { name: 'content.showFacebook', label: 'Facebook anzeigen?', type: 'select', options: ['true', 'false'] },
            { name: 'content.showInstagram', label: 'Instagram anzeigen?', type: 'select', options: ['true', 'false'] },
            { name: 'content.showLinkedIn', label: 'LinkedIn anzeigen?', type: 'select', options: ['true', 'false'] },
            { name: 'content.showX', label: 'X (Twitter) anzeigen?', type: 'select', options: ['true', 'false'] },
            { name: 'content.showYouTube', label: 'YouTube anzeigen?', type: 'select', options: ['true', 'false'] }
          ]
        },
        {
          title: 'Darstellung & Farben',
          fields: [
            { name: 'content.colorMode', label: 'Farb-Modus', type: 'select', options: ['brand', 'custom'] },
            { name: 'content.customColor', label: 'Benutzerdefinierte Farbe', type: 'color' },
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['left', 'center', 'right'] },
            { name: 'content.size', label: 'Icon-Box Größe (z.B. 32px)', type: 'text' },
            { name: 'content.gap', label: 'Abstand', type: 'text' }
          ]
        }
      ]
    }
  ]
});
